import React from 'react';
import { CheckCircle2, Clock, XCircle, AlertCircle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Modern Status Badge Component with new design system
 */
const StatusBadge = ({ status, size = 'md' }) => {
  const { isRTL, t } = useLanguage();
  
  const styles = {
    approved: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
    pending: 'bg-amber-50 text-amber-700 ring-amber-600/20',
    changes_requested: 'bg-rose-50 text-rose-700 ring-rose-600/20',
    needs_changes: 'bg-rose-50 text-rose-700 ring-rose-600/20',
    rejected: 'bg-rose-50 text-rose-700 ring-rose-600/20',
    draft: 'bg-slate-50 text-slate-700 ring-slate-600/20'
  };
  
  const labels = {
    approved: t('approved_status'),
    pending: t('pending'),
    changes_requested: t('needs_changes'),
    needs_changes: t('needs_changes'),
    rejected: t('needs_changes'),
    draft: t('pending')
  };

  const Icons = {
    approved: CheckCircle2,
    pending: Clock,
    changes_requested: XCircle,
    needs_changes: XCircle,
    rejected: XCircle,
    draft: AlertCircle
  };

  const Icon = Icons[status] || Clock;

  const sizes = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
    lg: 'w-4 h-4'
  };

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-md font-medium ring-1 ring-inset ${styles[status] || styles.pending} ${sizes[size]}`}>
      <Icon className={iconSizes[size]} />
      <span>{labels[status] || labels.pending}</span>
    </span>
  );
};

export default StatusBadge;

